import * as React from 'react'
import { BPMChart } from '../../../../components/Chart'
import { BPMAnalyticsAPI } from '../../../../api'

export const SubGenreChart: React.FunctionComponent = (props) => {
    return (
        <BPMChart {...props} title='Sub Genres' type='doughnut' subTitle={`Top 15 by downloads`}
            onRequestLoad={(options, signal) => {
                return BPMAnalyticsAPI.get<any>('downloads/create/byGroup', options, signal)
            }} additionalParams={{ groupBy: 'sub_genre_name', limit: 15 }}
            allowedTypes={['spline', 'bar', 'doughnut', 'pie', 'tree']}
            series={{
                name: 'Downloads', valueField: 'count', argumentField: 'sub_genre_name'
            }}>
        </BPMChart>
    )
}


// WEBPACK FOOTER //
// ./src/pages/Statistics/Downloads/charts/SubGenreChart.tsx